const getCodeFromUrl = () => {
    return window.location.pathname.replace("/", "");
  };
export default getCodeFromUrl;